'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { ChakraProvider } from '@chakra-ui/react';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactFlowProvider } from '@xyflow/react';
import { enableMapSet } from 'immer';
import { Toaster } from '@/components/ui/toaster';
import queryClient from '@/services/queryClient';
import { trpc } from '@/utils/trpc';
import { CSPostHogProvider } from './providers';
import { system } from './theme';
enableMapSet();
interface ClientProviderProps {
  children: React.ReactNode;
}
function ClientProvider(t0) {
  const $ = _c(5);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <ReactFlowProvider>{children}</ReactFlowProvider>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Toaster />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1) {
    t3 = <React.StrictMode><CSPostHogProvider><QueryClientProvider client={queryClient}><ChakraProvider value={system}>{t1}{t2}</ChakraProvider></QueryClientProvider></CSPostHogProvider></React.StrictMode>;
    $[3] = t1;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}
export default trpc.withTRPC(ClientProvider) as React.ComponentType<ClientProviderProps>;